export default "__VITE_ASSET__DMHw6Nvq__"